var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"max-width"},[_c('v-pagination',_vm._b({attrs:{"length":_vm.pages},model:{value:(_vm.innerPage),callback:function ($$v) {_vm.innerPage=$$v},expression:"innerPage"}},'v-pagination',_vm.pagerAttrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }